<template>
  <div class="system-login">
    <span class="logo" @click="toSystem"><img :src="groupInfo.imageUrl" /></span>
    <span class="title">{{ groupInfo.groupName }}</span>
    <span class="angle-icon">
      <el-popover placement="bottom-end" trigger="hover" popper-class="boss-open-menu">
        <div class="boss-menu-list">
          <ul class="position_relative">
            <li class="color_fff cursor_pointer" @click="quitLogin">退出</li>
          </ul>
        </div>
        <div slot="reference"><i class="el-icon-caret-bottom"></i></div>
      </el-popover>
    </span>
    <span class="user-icon"><img src="/static/images/system/user2.png" /></span>
    <span v-if="isTransactionDetails" class="menu-text" @click="transactionDetails()">结算系统</span>
    <span v-if="isTransactionDetails" class="user-icon"><img src="/static/images/system/transactionDetails.png" /></span>
    <span v-if="isPolicy" class="menu-text" @click="toPolicy()">控制策略优化</span>
    <span v-if="isPolicy" class="user-icon"><img src="/static/images/svolt/policy/lianchuan-002.png" /></span>
  </div>
</template>

<script>
import { removeToken, removeInfo, getInfo } from '@/utils/auth';
import USERAPI from '@/api/user';
import JQ from 'jquery';
export default {
  props: {
    path:{
      type:String
    }
  },
  data() {
    return {
      username: '',
      groupInfo: {},
      times: '', // 具体时间
      dates: '', // 具体日期
      weeks: '', // 具体星期几
      isIntellectDevOps: false,
      isWorkOrder: false,
      isKnowledgeGraph: false,
      isTransactionDetails: false,
      isPolicy: false,
      isMessage: false
    };
  },
  methods: {
    //初始数据
    init() {
      let self = this;
      let tempAuth = localStorage.getItem('ActiveModule');
      if (tempAuth && (this.$route.name == 'Svolt' || this.$route.name == 'workOrder' || this.$route.name == 'knowledgeGraph' || this.$route.name == 'transactionDetails' || this.$route.name == 'messageCenter')) {
        let json = JSON.parse(tempAuth);
        json.item.forEach(item => {
          if (item.resourceId == '30167') {
            self.isIntellectDevOps = true;
            self.isWorkOrder = true;
          }
          if (item.resourceId == '225') {
            self.isIntellectDevOps = true;
            self.isKnowledgeGraph = true;
          }
          if (item.resourceId == '30254') {
            self.isMessage = true;
          }
        });
        this.isTransactionDetails = true;
        this.isPolicy = true;
      }
    },
    toSystem() {
      let path = this.path?this.path:'/system';
      this.$router.push({
        path: path
      });
    },
    //退出登录
    quitLogin() {
      USERAPI.logout().then(res => {
        removeToken();
        this.$router.push({
          path: '/login'
        });
      });
    },
    currentTime() {
      setInterval(this.formatDate, 1000);
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      month = month < 10 ? '0' + month : month; // 如果只有一位，则前面补零
      let day = date.getDate(); // 日
      day = day < 10 ? '0' + day : day; // 如果只有一位，则前面补零
      let week = date.getDay(); // 星期
      let weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
      this.times = `${hour}:${minute}:${second}`;
      this.dates = `${year}/${month}/${day}`;
      this.weeks = `${weekArr[week]}`;
    },
    handleCommand(command) {
      let path = '/' + command;
      this.$router.push({
        path: path
      });
    },
    //工单管理
    workOrderBtn() {
      this.$router.push({
        path: '/workOrder'
      });
    },
    //知识图谱
    knowledgeGraphBtn() {
      this.$router.push({
        path: '/knowledgeGraph'
      });
    },
    //结算系统
    transactionDetails() {
      this.$router.push({
        path: '/transactionDetails'
      });
    },
    //控制策略优化
    toPolicy(){
      this.$router.push({
        path: '/svolt/project/policy'
      });
    },
    //消息中心
    messageCenter() {
      this.$router.push({
        path: '/messageCenter'
      });
    }
  },
  created() {
    let self = this;
    this.$nextTick(function() {
      let info = JSON.parse(getInfo());
      if (info) {
        self.username = info.user.username;
        self.groupInfo = info.groupInfo;
        document.title = self.groupInfo.groupName;
      }
    });
  },
  mounted() {
    // 初始化
    this.init();
    this.currentTime();
  },
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
    }
  }
};
</script>

<style lang="scss" scoped>
.system-login {
  height: 80px;
  line-height: 80px;
  background: url('/static/images/system/top-01.png') no-repeat;
  background-size: 100% 100%;

  .logo {
    height: 80px;
    float: left;
    margin-left: 20px;
    margin-top: -5px;
    img {
      // width: 92px;
      height: 44px;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .title {
    height: 80px;
    line-height: 80px;
    float: left;
    margin-left: 10px;
    font-size: 32px;
    font-family: 'YouSheBiaoTiHei';
    color: #00fde8;
    background-image: -webkit-linear-gradient(bottom, #e6fef9, #90cfff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .user-icon,
  .menu-dropdown-icon,
  .user-text,
  .menu-dropdown-text,
  .menu-text,
  .angle-icon,
  .header_border_right {
    float: right;
    height: 60px;
    line-height: 60px;
  }

  .user-icon {
    img {
      width: 24px;
    }
  }

  .user-text {
    font-size: 18px;
    color: #76defc;
    margin: 0px 5px;
  }

  .menu-dropdown-text,
  .menu-text {
    color: #76defc;
    font-size: 16px;
    margin: 0 5px;
  }

  .menu-text {
    cursor: pointer;
    margin-right: 15px;
  }

  .angle-icon,
  .menu-dropdown-icon {
    width: auto;
    margin-right: 20px;

    .el-icon-caret-bottom {
      color: #76defc;
      font-size: 12px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  // .menu-dropdown-icon {
  //   margin-right: 10px;
  // }

  .header-timer {
    width: auto;
    margin-right: 10px;
    display: inline-block;
    float: right;
    margin-top: 5px;

    .header_time {
      height: 44px;
      margin: 6px 0;
    }

    .header_time_hour {
      font-size: 20px;
      font-weight: 700;
      line-height: 1;
      color: #aaf3ff;
      letter-spacing: 1px;
      margin-bottom: 6px;
    }

    .header_time_date {
      font-size: 12px;
      line-height: 1;
    }

    .header_time_date .span {
      margin-right: 4px;
    }
  }

  .header_border_right {
    width: 1px;
    opacity: 0.27;
    background: #79d7ff;
    height: 24px;
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg);
    margin: 20px 20px;
  }
}
</style>

<style lang="scss">
.popover_list {
  display: inline-block;
}

.popover_list_text {
  font-size: 16px;
  color: #79d7ff;
  line-height: 1;
}

.popover_list_iconLeft {
  width: 20px;
  height: 20px;
  left: 0;
  top: calc(50% - 2px);
}

.popover_list_iconRight {
  right: 0;
  font-size: 12px;
}

.el-popover {
  padding: 0px !important;
  min-width: 80px;
  background: transparent;
  text-align: center;

  .popper__arrow {
    display: none;
  }
}

.boss-dropdown-menu {
  >>> .el-dropdown-link {
    cursor: pointer;
    color: #76defc !important;
  }

  >>> .el-icon-arrow-down {
    font-size: 12px;
  }

  >>> .el-dropdown-menu--medium {
    background-color: rgba(1, 34, 92, 0.8) !important;
    border: 1px solid rgb(8, 66, 148) !important;
  }

  >>> .popper__arrow,
  >>> .popper__arrow::after {
    border-bottom-color: #084494 !important;
    display: none !important;
  }

  >>> .el-dropdown-menu__item {
    color: #76defc;
    font-weight: 600;
    margin: 5px 0;
  }

  >>> .el-dropdown-menu__item:focus,
  >>> .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: rgb(1, 34, 91);
    color: #fff;
  }
}

//区分下拉弹窗
.boss-open-menu {
  position: absolute;
  background: transparent !important;
  border: 1px solid rgb(8, 66, 148);
  min-width: auto !important;
  z-index: 2000;
  font-size: 14px;
  word-break: break-all;
  text-align: center;
  .boss-menu-list ul {
    border-radius: 2px;
  }

  .boss-menu-list ul,
  .boss-menu-list li {
    list-style-type: none;
    margin: 0;
    z-index: 1;
  }

  .boss-menu-list li {
    padding: 8px 15px;
    font-size: 16px;
    line-height: 1;
    background-color: rgba(1, 34, 92, 0.8) !important;
    color: #76defc;
  }

  .boss-menu-list li:hover,
  .boss-menu-list li:active {
    background-color: rgb(1, 34, 91);
    color: #fff;
  }
  .popper__arrow {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/header.vue